import http from "@/common/utils/http"

/**
 * 添加收藏（与 www 站 spotoverseascenter 一致）
 */
export async function addFavorite(productId: string, category: string) {
	return http.post<null, { code?: number; msg?: string }>(
		`/spotoverseascenter/v1/favorite/add?product_id=${productId}&category=${category}`,
		{ showOriginResponse: true }
	)
}

/**
 * 取消收藏
 */
export async function delFavorite(productId: string, category: string) {
	return http.post<null, { code?: number; msg?: string }>(
		`/spotoverseascenter/v1/favorite/del?product_id=${productId}&category=${category}`,
		{ showOriginResponse: true }
	)
}
